export const CATALOG_PAGE_TYPES = <Readonly<['PRODUCT', 'CATEGORY', 'DYNAMIC_CATEGORY']>>[
  'PRODUCT',
  'CATEGORY',
  'DYNAMIC_CATEGORY',
]

export const CLOTHING_CATEGORY_UID = 'MjQ='

export const BASIC_LETTERS = 'A-Za-z'
export const ACCENTED_CHARACTERS = 'À-ž'
export const LETTERS_WITH_ACCENTS = `${BASIC_LETTERS}${ACCENTED_CHARACTERS}`

export const RESTRICTED_SKUS_FOR_ENGRAVING_ACCENTED_CHARACTERS = ['MJ05579', 'MJ05580'] as const
export const NEW_CATEGORY_ID = 829
